import InputEditableField from 'src/components/fields/InputEditableField/InputEditableField';

export default InputEditableField;
